import React, { useEffect, useState } from 'react'
import { Card, Radio, Select, Space } from 'antd'
import GroupsPie, { GROUPS_DEFAULT_STUDENT_KEY } from './GroupsPie'
import { useParams } from 'react-router'
import { useFetchGroupsAnalyticsQuery } from '../../../../../../../store/apis/analytics.api'
import Text from 'antd/es/typography/Text'

const useSetSelectedStudentsKeyToAllWhenInModel = (analytics, setSelectedStudentsKey) => {
    useEffect(() => {
        if (analytics && analytics.current?.length === 0) setSelectedStudentsKey('all')
    }, [analytics])
}

const GroupsPieCard = () => {
    const { token } = useParams()
    const { data: analytics, isFetching } = useFetchGroupsAnalyticsQuery({ token })
    const [selectedComponentIndex, setSelectedComponentIndex] = useState(0)
    const [selectedStudentKey, setSelectedStudentsKey] = useState(GROUPS_DEFAULT_STUDENT_KEY)
    const componentOptions = analytics?.all.map((component, index) => ({
        label: component.componentName,
        value: index,
    }))

    const studentsOptions = [
        ...(analytics?.current?.length ? [{ label: 'My', value: 'current' }] : []),
        { label: 'All', value: 'all' },
    ]

    useSetSelectedStudentsKeyToAllWhenInModel(analytics, setSelectedStudentsKey)

    const extra = (
        <Space>
            {studentsOptions.length > 1 && (
                <label className='d-flex'>
                    <Text type='secondary' className='d-flex-center mr-8'>
                        Students
                    </Text>
                    <Radio.Group
                        options={studentsOptions}
                        value={selectedStudentKey}
                        onChange={event => setSelectedStudentsKey(event.target.value)}
                        optionType='button'
                        size='small'
                    />
                </label>
            )}
            <label className='d-flex'>
                <Text type='secondary' className='d-flex-center mr-4'>
                    Component
                </Text>
                <Select
                    options={componentOptions}
                    onChange={value => setSelectedComponentIndex(value)}
                    defaultValue={0}
                    loading={isFetching}
                    popupMatchSelectWidth={false}
                    getPopupContainer={triggerNode => triggerNode.parentNode}
                    showSearch
                    optionFilterProp='label'
                />
            </label>
        </Space>
    )

    return (
        <Card title='Submissions Distribution by Groups' extra={extra}>
            <GroupsPie
                token={token}
                selectedComponentIndex={selectedComponentIndex}
                selectedStudentKey={selectedStudentKey}
            />
        </Card>
    )
}

export default GroupsPieCard
